import { useCallback } from "react";
import { TokenCell } from "../../../components/grid/cells/TokenCell";
import { DESTROY, makeColumns, UPDATE, useAdministrateTable, useCreatePermission } from "../../utils";
import { SystemConfigLayout } from "../../components/SystemConfigLayout";
import { Container, Row } from "reactstrap";
import { Toolbar } from "../../../components/Toolbar";
import { AdministrateTable } from "../../components/AdministrateTable";
import { BoolCell } from "../../../components/grid/cells/BoolCell";
import { BoolFilter } from "../../../components/inputs/BoolFilter";
import { AddCustomerSuccessAutoAssignmentModal } from "./components/AddCustomerSuccessAutoAssignmentModal";
import { AdministrateEnumFilter } from "../../components/AdministrateEnumFilter";
import { StatusDisplayer } from "../../submit_right/phone_responses/PhoneResponsesIndex";
import { humanizeString } from "../../../util/formatters";
import { CustomerSuccessAutoAssignmentActionCell } from "./components/CustomerSuccessAutoAssignmenActionCell";

const useColumns = makeColumns(() => [
  {
    id: "id",
    accessor: "id",
    Header: "ID",
    Cell: TokenCell,
    width: 60,
  },
  {
    id: "status",
    accessor: "status",
    Header: "Status",
    Filter: (props) => (
      <AdministrateEnumFilter
        {...props}
        resourceUrl="/admin/enums/prior_auth_statuses.json"
        valueKey="id"
        labelKey="label"
        placeholder="Select Status..."
      />
    ),
    Cell: (props) => <StatusDisplayer status={props.value || "none"} />,
  },
  {
    id: "comment_type",
    accessor: (r) => humanizeString(r.commentType || "none"),
    Header: "Comment Type",
    Filter: (props) => (
      <AdministrateEnumFilter
        {...props}
        resourceUrl="/admin/enums/comment_type_options.json"
        valueKey="id"
        labelKey="label"
        placeholder="Select Comment Type..."
      />
    ),
  },
  {
    id: "comment_regex",
    accessor: "commentRegex",
    Header: "Comment Regex",
    Cell: TokenCell,
  },
  {
    id: "assign_to_customer_success",
    accessor: "assignToCustomerSuccess",
    Header: "Assign To Customer Success",
    Cell: BoolCell,
    Filter: BoolFilter,
  },
  {
    id: "escalate_case",
    accessor: "escalateCase",
    Header: "Escalate Case",
    Cell: BoolCell,
    Filter: BoolFilter,
  },
  {
    id: "dont_add_task",
    accessor: "dontAddTask",
    Header: "Don't Add Task",
    Cell: BoolCell,
    Filter: BoolFilter,
  },
  {
    id: "add_auto_reply_for_not_due_task",
    accessor: "addAutoReplyForNotDueTask",
    Header: "Add Auto Reply",
    Cell: BoolCell,
    Filter: BoolFilter,
  },
  {
    id: "actions",
    accessor: "Actions",
    Header: "Actions",
    Cell: CustomerSuccessAutoAssignmentActionCell,
    disableFilters: true,
    disableSortBy: true,
  },
]);

export const CustomerSuccessAutoAssignmentIndex = () => {
  const { tableRef, allFilters, setTableFilters } = useAdministrateTable();
  const columns = useColumns();
  const [canCreate] = useCreatePermission("CustomerSuccessAutoAssignment");

  const onAdd = useCallback(
    (message, errorDetails = []) => {
      tableRef.current?.refresh?.();
      tableRef.current?.setMessage?.(message, errorDetails.length ? "warning" : "success", errorDetails);
    },
    [tableRef]
  );

  return (
    <SystemConfigLayout title="Customer Success Round Robin">
      <Container fluid>
        <Row className="align-items-center mb-3">
          <Toolbar className="ml-auto">{canCreate && <AddCustomerSuccessAutoAssignmentModal onAdd={onAdd} color="primary" />}</Toolbar>
        </Row>
      </Container>

      <AdministrateTable
        resourceUrl={"/admin/customer_success_auto_assignments.json"}
        resourceName={"customer_success_auto_assignment"}
        permissions={[UPDATE, DESTROY]}
        onFilteredChange={setTableFilters}
        columns={columns}
        ref={tableRef}
      />
    </SystemConfigLayout>
  );
};
